/*
 * @Description  : jsbridge 相关工具集
 * @usage        :
 * @Date         : 2021-09-27 19:04:23
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-02 11:55:30
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/jsbridge.ts
 */
import { getWsmqqWithRetry } from './script';

interface IRawBenchMarkRsp {
  data: IRawBenchMarkInfo;
}
interface IRawBenchMarkInfo {
  benchMark: string;
}
/**
 * 获取机型档位
 *
 * @export
 */
export async function getBenchMark(): Promise<IRawBenchMarkInfo | null> {
  try {
    const mqq = await getWsmqqWithRetry();
    if (!mqq) return null;

    return await new Promise((resolve) => {
      mqq.invoke('weishi', 'getBenchMark', (result: IRawBenchMarkRsp) => {
        resolve(result.data);
      });
    });
  } catch (err) {
    console.error('[getBenchMark] 发生异常：', err);
    return null;
  }
}
